import { connect } from 'react-redux';

import { Features, IFeaturesDispatchProps, IFeaturesProps } from './Features';
import { NavigationLinkTypes } from '../../constants/navigation';
import { IState } from '../../store';
import { setNavigationLink } from '../../store/navigation/actions';
import { TTypedThunkDispatch } from '../../types/store';

export function mapStateToProps(state: IState): IFeaturesProps {
  return {
    featureList: state.villageData.village.featureList ?? [],
  };
}

export function mapDispatchToProps(dispatch: TTypedThunkDispatch): IFeaturesDispatchProps {
  return {
    setNavigationLink: () => dispatch(setNavigationLink(NavigationLinkTypes.Features)),
  };
}

export const FeaturesContainer = connect<IFeaturesProps, IFeaturesDispatchProps>(
  mapStateToProps,
  mapDispatchToProps,
)(Features);
